// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {
    .budgetElement {
        width: 70%;
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;
        font-weight: 700;
        label {
            font-size: 16px;
            font-weight: 500;
        }

        .elements {
            margin: 15px 0px;
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #D5D5D5;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

}

.compact-datepicker {
  width: 100%;
  max-width: 250px;
  height: 38px;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
  box-sizing: border-box;
}

.react-datepicker {
  font-size: 13px;
}

.react-datepicker__current-month {
  font-size: 14px;
  font-weight: 600;
}

.react-datepicker__day-name,
.react-datepicker__day {
  width: 2rem;
  line-height: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ProjectManagement/CreateProject/CreatProject.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;QAChB;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;AAEJ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".budgetContainer {\r\n    .budgetElement {\r\n        width: 70%;\r\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\r\n        border-radius: 5px;\r\n        padding: 20px 50px;\r\n        background-color: white;\r\n        font-weight: 700;\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #D5D5D5;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n            color: black;\r\n        }\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.compact-datepicker {\r\n  width: 100%;\r\n  max-width: 250px;\r\n  height: 38px;\r\n  padding: 8px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  font-size: 13px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.react-datepicker {\r\n  font-size: 13px;\r\n}\r\n\r\n.react-datepicker__current-month {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.react-datepicker__day-name,\r\n.react-datepicker__day {\r\n  width: 2rem;\r\n  line-height: 2rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
